<div id="anc-seat-reservation" class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <div class="p-heading-area01">
    <div class="p-heading-area01__title">
      <h2 class="c-heading-2" role="heading" aria-level="2">
        <span class="c-text-with-tooltip">
          <span class="c-text-with-tooltip__text" [innerHTML]="'label.asr' | staticMsg"></span>
          <span class="c-text-with-tooltip__tooltip js-tooltip">
            <button
              id="seat-reservation-help"
              class="c-text-with-tooltip__btn js-tooltip-btn"
              [aswTooltip]="getTooltipSeatReservation"
              [tooltipTop]="0"
              aria-expanded="false"
            >
              <!-- TODO + Q&A UIUXS2-10261 -->
              <span class="u-visually-hidden">Hint</span>
            </button>
          </span>
        </span>
      </h2>
    </div>
  </div>

  <div [ngClass]="['p-plan-table js-plan-table01-item', isScrollSeatReservation ? 'is-scroll' : '']">
    <div class="p-plan-table__contents">
      <div class="p-plan-table__scroll">
        <asw-table-slider id="seat-reservation-slider" (isScrollChange)="scrollSeatReservation($event)">
          <div class="p-plan-table__scroll-view">
            <div class="p-plan-table__scroll-inner js-plan-table01-scroll" #detailPanel>
              <table class="c-plan-table01 c-plan-table01--6col js-plan-table01" #scrollPanel>
                <caption class="u-visually-hidden" [innerHTML]="'label.asr' | staticMsg"></caption>
                <thead class="c-plan-table01__head">
                  <tr class="c-plan-table01__inner">
                    <td class="c-plan-table01__col">
                      <div class="c-plan-table01__col-inner"></div>
                    </td>
                    <!-- [3-4] セグメント情報 -->
                    <ng-container *ngFor="let flight of seatFlightInforList">
                      <th class="c-plan-table01__col" scope="col">
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item c-plan-table01__col--em">
                            <span class="c-flight-info01__title-airport">
                              <span class="c-flight-info01__title-airport-departure">
                                <!-- [3-5] 出発地 -->
                                {{ getlocationNameDeparture(flight?.departure) }}
                                <span class="c-flight-info01__title-airport-to">
                                  <span
                                    class="u-visually-hidden"
                                    [innerHTML]="'alt.toOfArrivalAndDeparture' | staticMsg"
                                  ></span>
                                  <span aria-hidden="true" [innerHTML]="'label.hyphen' | staticMsg"></span>
                                </span>
                              </span>
                              <!-- [3-6] 到着地 -->
                              <span class="c-flight-info01__title-airport-arrival">
                                {{ getlocationNameArrival(flight.arrival) }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody class="c-plan-table01__body">
                  <ng-container *ngFor="let traveler of seatPassengerInforList">
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col" scope="row">
                        <div class="c-plan-table01__col-inner">
                          <!-- [3-8] 搭乗者姓名 -->
                          <div class="c-plan-table01__col-item c-plan-table01__col-item--em">
                            {{ getTravelerName(traveler) }}
                          </div>
                          <div
                            class="c-plan-table01__col-item c-plan-table01__col-item--gray60"
                            *ngIf="isAccompanyingTraveler(traveler)"
                          >
                            {{ getAccompanyingTraveler(traveler) }}
                          </div>
                        </div>
                      </th>
                      <!-- [3-9] セグメント毎申込状況 -->
                      <ng-container *ngFor="let flight of seatFlightInforList">
                        <td class="c-plan-table01__col">
                          <asw-seat-reservation-item
                            [flight]="flight"
                            [traveler]="traveler"
                            [pnr]="pnr"
                            [seatReservationStatus]="seatReservationStatus"
                          ></asw-seat-reservation-item>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>

                  <tr class="c-plan-table01__inner">
                    <td class="c-plan-table01__col">
                      <div class="c-plan-table01__col-inner" *ngIf="isSeatChange(seatFlightInforList[0])"></div>
                    </td>
                    <ng-container *ngFor="let flight of seatFlightInforList; let i = index">
                      <td class="c-plan-table01__col">
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item">
                            <!-- [3-16] 座席変更 -->
                            <button
                              class="c-btn-primary c-btn-primary--xs"
                              aria-label=""
                              id="'seat-change-btn' + {{ i }}"
                              (click)="clickChange(flight)"
                              [disabled]="isSeatChange(flight) !== true"
                            >
                              <span class="c-btn-primary__text" [innerHTML]="'label.changeButton' | staticMsg"></span>
                            </button>
                          </div>
                        </div>
                      </td>
                    </ng-container>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </asw-table-slider>
      </div>
    </div>
  </div>
</div>
